import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'mobx-react';

// Bootstrap
import './custom.scss';
// Customer css styles
import './index.css';

// AWS
import Amplify from 'aws-amplify';
import aws_exports from './aws-exports';

import SecureApp from './SecureApp';

// Stores
import { BloodworkStore } from './stores/bloodwork-store';
import { BloodworkEntryStore } from './stores/bloodwork-entry-store';

import { ClientStore } from './stores/client-store';
import { ClientEntryStore } from './stores/client-entry-store';
import { UserStore } from './stores/user-store';
import { UserProfileStore } from './stores/user-profile-store';
import { FurtherConsiderationsEntryStore } from './stores/further-considerations-entry-store';
import { FurtherConsiderationsStore } from './stores/further-considerations-store';
import { LoadingStore } from './stores/loading-store';
import { UserProfileUIStore } from './stores/user-profile-ui-store';

const noop = () => {
  // Do Nothing
};
// Disable regular logging in production since we would have to eject to do this
if (process.env.NODE_ENV === 'production') {
  console.log = noop;
  console.warn = noop;
} else {
  console.log(`Running in ${process.env.NODE_ENV} mode.`);
}

// Log env vars
console.log(`ENV: ${process.env.NODE_ENV}`);

// Configure AWS
Amplify.configure(aws_exports);

const loadingStore = new LoadingStore();

const userProfileStore = new UserProfileStore();
const userProfileUIStore = new UserProfileUIStore(
  userProfileStore,
  loadingStore,
);

const clientStore = new ClientStore();
const clientEntryStore = new ClientEntryStore(clientStore, loadingStore);

const furtherConsiderationsStore = new FurtherConsiderationsStore();
const furtherConsiderationsEntryStore = new FurtherConsiderationsEntryStore(
  furtherConsiderationsStore,
  loadingStore,
);
// // define MobX UI stores for injection by components
const stores = {
  userStore: new UserStore(),
  userProfileStore,
  userProfileUIStore,
  bloodworkEntryStore: new BloodworkEntryStore(
    new BloodworkStore(),
    loadingStore,
    userProfileUIStore,
  ),
  clientEntryStore,
  furtherConsiderationsEntryStore,
  loadingStore,
};
// TODO: Revisit ErrorBoundary usage here
ReactDOM.render(
  <Provider {...stores}>
    <SecureApp />
  </Provider>,
  document.getElementById('root') as HTMLElement,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
